module.exports = __webpack_public_path__ + "img/icon_wealth.4e684a7d.png";